import { render, staticRenderFns } from "./MobDiagensBanner.vue?vue&type=template&id=28f8624e&scoped=true"
import script from "./MobDiagensBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MobDiagensBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobDiagensBanner.vue?vue&type=style&index=0&id=28f8624e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8624e",
  null
  
)

export default component.exports